import { lazy, Suspense } from "react";
import { PATH_ONBOARDING } from "./paths";
import AuthGuard from "@/guards/AuthGuard";
import { Outlet } from "react-router-dom";
import Loader from "@/components/Loader";

const OnboardingContainer = lazy(() => import("@/pages/onboarding/onboarding.container"));

const onboardingRoutes = [
  {
    path: PATH_ONBOARDING,
    element: (
      <AuthGuard>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </AuthGuard>
    ),
    children: [
      {
        element: <OnboardingContainer />,
        index: true,
      },
    ],
  },
];

export default onboardingRoutes;
